import request from "@/utils/request";

export function getAll(data, page_size, currentPage) {
  return request({
    url: "random-inventory/getAll/" + page_size + "?page=" + currentPage,
    method: "post",
    data,
  });
}

export function store(quantity) {
  return request({
    url: "random-inventory",
    method: "post",
    data: { quantity },
  });
}

export function inventoryDownload(quantity, data) {
  return request({
    url: `/random-inventory/generate-random/${quantity}`,
    method: "post",
    data,
    responseType: "blob",
  }).then((response) => {
    // Verificar si la respuesta es un error
    const contentType = response.headers["content-type"];
    if (contentType && contentType.includes("application/json")) {
      // Convertir el blob a JSON para obtener el mensaje de error
      return response.data.text().then((text) => {
        const errorData = JSON.parse(text);
        throw new Error(errorData.error || "Error desconocido");
      });
    }
    // Si no es un error, devolver el blob
    return response;
  });
}

export function uploadInventory(id, data) {
  return request({
    url: `/random-inventory/${id}/upload`,
    method: "post",
    data,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
}

export function downloadInventoryCheck(id) {
  return request({
    url: `random-inventory/download/${id}`,
    method: "get",
    responseType: "blob",
  }).then((response) => {
    // Verificar si la respuesta es un error
    const contentType = response.headers["content-type"];
    if (contentType && contentType.includes("application/json")) {
      // Convertir el blob a JSON para obtener el mensaje de error
      return response.data.text().then((text) => {
        const errorData = JSON.parse(text);
        throw new Error(errorData.error || "Error desconocido");
      });
    }
    // Si no es un error, devolver el blob
    return response;
  });
}

export function deleteData(id) {
  return request({
    url: "random-inventory/" + id,
    method: "delete",
  });
}
